/**
 * @file This file defines the view component for the Home Page. Containing different sections of home page.
 * @module HomePageView
 */

import React, { useState } from "react";

import dynamic from "next/dynamic";
import Navbar from "./NavBar";
import HeroSection from "./HeroSection";

const MaticSeesMess = dynamic(() =>
  import("@/components/MaticSeesMessSection")
);
const MessesHappen = dynamic(() => import("@/components/MessesHappenSection"));
const LessTimeCleaning = dynamic(() => import("@/components/LessTimeCleaning"));
const LearnHomeDescription = dynamic(() =>
  import("@/components/LearnHomeSection/LearnHomeDescription")
);
const HeyMaticDescription = dynamic(() =>
  import("@/components/HeyMatic/HeyMaticDescription")
);
const InnovationWorthMain = dynamic(() =>
  import("@/components/InnovationWorthCelebrating/InnovationWorthMain")
);
const FutureOfRobotics = dynamic(() => import("@/components/FutureOfRobotics"));
const CarouselMain = dynamic(() =>
  import("@/components/carouselSection/CarouselMain")
);
const MoppingAndVaccuming = dynamic(() =>
  import("@/components/MoppingSection")
);


/**
 * Functional component representing the view for the Home Page.
 * @function HomePageView
 * @param {Object} props - The properties passed to the component.
 * @param {Array} props.entries - Entries for the home page.
 * @param {Array} props.pageLoadAnimationentries - Entries for page load animation.
 * @param {Array} props.homePage2 - Entries for the second section of the home page.
 * @param {Array} props.commonAssets - Common assets for the home page.
 * @returns {JSX.Element} The rendered Home Page view component.
 */

const HomePageView = ({
  entries,
  pageLoadAnimationentries,
  homePage2,
  commonAssets,
  maticProduct,
}) => {
  const entryFields = entries[0]?.fields;
  const homePage2Fields = homePage2[0]?.fields;
  const commonAssetsFields = commonAssets[0]?.fields;
  const [herosectionInView, setHeroSectionInView] = useState(false);
  const [isUberBannerPresent, setIsUberBannerPresent] = useState(true);

  return (
    <>
      <Navbar
        data={entryFields}
        herosectionInView={herosectionInView}
        setIsUberBannerPresent={setIsUberBannerPresent}
      />
      <HeroSection
        isUberBannerPresent={isUberBannerPresent}
        data={entryFields}
        setHeroSectionInView={setHeroSectionInView}
        pageLoadAnimationData={pageLoadAnimationentries[0]?.fields}
        commonAssets={commonAssetsFields}
        maticProduct={maticProduct}
      />
      <MaticSeesMess data={entryFields} />
      <MoppingAndVaccuming data={entryFields} />
      <LearnHomeDescription data={entryFields} />
      <HeyMaticDescription data={homePage2Fields} />
      <MessesHappen
        data={homePage2Fields}
        commonAssets={commonAssetsFields}
      />
      <LessTimeCleaning data={homePage2Fields} />
      <CarouselMain data={entryFields} />
      <FutureOfRobotics data={homePage2Fields} />
      <InnovationWorthMain
        data={homePage2Fields}
        commonAssets={commonAssetsFields}
        maticProduct={maticProduct}
      />
    </>
  );
};

export default HomePageView;
